module.exports = __webpack_public_path__ + "img/20190701155406QQ截图20190701150057.b6418acf.png";